import React, { useState, useEffect } from "react";
import {
  IonHeader,
  IonTitle,
  IonModal,
  IonButton,
  IonToolbar,
  IonContent,
  IonItem,
  IonInput,
  IonGrid,
  IonRow,
  IonCol,
  IonFooter,
  IonLabel,
  IonRippleEffect,
  IonIcon,
  IonText,
  IonBackButton,
  IonButtons,
} from "@ionic/react";
// import { MobXProviderContext } from "mobx-react";
import {
  addCircleOutline,
  phonePortraitOutline,
  businessOutline,
} from "ionicons/icons";
// import Countries from '../countries.json';

const LineasModal = ({ showModal, onDidDismiss, toEdit }) => {
  const [name, setName] = useState("");
  const [number, setNumber] = useState("");
  const [errorName, setErrorName] = useState("");
  const [errorPhone, setErrorPhone] = useState("");

  useEffect(() => {
    if (toEdit != null) {
      setName(toEdit.item[0]);
      setNumber(toEdit.item[1]);
    }
  }, [toEdit]);

  const handleSubmit = () => {
    let errores = false;
    if (name === "") {
      setErrorName("Este campo es obligatorio");
      errores = true;
    } else {
      setErrorName("");
    }
    if (number === "") {
      setErrorPhone("Este campo es obligatorio");
      errores = true;
    } else {
      setErrorPhone("");
    }

    if (!errores) {
      setName("");
      setNumber("");

      let ret = {
        name,
        number,
      };
      if (toEdit != null) {
        ret.id = toEdit.id;
      }
      onDidDismiss({ result: ret });
    }
  };

  return (
    <IonModal mode="ios" isOpen={showModal} onDidDismiss={() => onDidDismiss()}>
      <IonHeader>
        <IonToolbar mode="ios">
          <IonButtons slot="start">
            <IonBackButton
              mode="ios"
              onClick={() => {
                setName("");
                setNumber("");
                setErrorName("");
                setErrorPhone("");
                onDidDismiss();
              }}
              defaultHref="/tabs/lineas"
              text="Cancelar"
            />
          </IonButtons>
          <IonTitle mode="ios">
            {toEdit != null ? "Editar línea" : "Nueva línea"}
          </IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonItem className="itemPadding">
          <IonLabel position="floating">Nombre de la línea/sucursal</IonLabel>
          <IonInput
            type="text"
            onIonInput={(e) => setName(e.target.value)}
            name="nombrelinea"
            required={true}
            value={name}
          />
          <IonIcon
            icon={businessOutline}
            slot="start"
            className="ion-align-self-end"
          />
        </IonItem>
        <IonText color="danger" className="ion-padding-start">
          <small>{errorName}</small>
        </IonText>
        <IonItem className="itemPadding">
          <IonLabel position="floating">Teléfono</IonLabel>
          <IonInput
            type="tel"
            name="number"
            required={true}
            onIonInput={(e) => setNumber(e.target.value)}
            value={number}
          />
          <IonIcon
            icon={phonePortraitOutline}
            slot="start"
            className="ion-align-self-end"
          />
        </IonItem>
        <IonText color="danger" className="ion-padding-start">
          <small>{errorPhone}</small>
        </IonText>
        <IonText className="textExample">
          <small>
            Debe incluir el código de su país al comienzo, sin signos especiales
            ni espacios (Ej: 573003001212)
          </small>
        </IonText>
      </IonContent>
      <IonFooter>
        <IonToolbar>
          <IonGrid>
            <IonRow>
              <IonCol>
                <IonButton
                  expand="full"
                  className="botonLineal"
                  onClick={() => {
                    handleSubmit();
                  }}
                >
                  {toEdit != null ? "Modificar" : "Agregar"}{" "}
                  <IonIcon slot="end" icon={addCircleOutline} />
                  <IonRippleEffect type="unbounded"></IonRippleEffect>
                </IonButton>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonToolbar>
      </IonFooter>
    </IonModal>
  );
};

export default LineasModal;
